module.exports = __webpack_public_path__ + "img/img-publicidad-negocio.fc92ea9b.webp";